import {useEffect, useState} from "react";
import {supabase} from "../../supabase";


export default (bucket: string, path: string | null | undefined, size: number = 175) => {

    const [avatarUrl, setAvatarUrl] = useState<string | null>(null)

    useEffect(() => {
        if (path) downloadImage(path)
        else setAvatarUrl(null)
    }, [path])

    async function downloadImage(path: string) {
        const {data, error} = await supabase
            .storage
            .from(bucket)
            .download(path, {
                transform: {
                    width: size*3,
                    height: size*3,
                    resize: "cover"
                }
            });

        if (error) {
            console.log('Error downloading image: ', JSON.stringify(error))
            setAvatarUrl(null)
            return
        }

        const fr = new FileReader()
        fr.readAsDataURL(data)
        fr.onload = () => {
            setAvatarUrl(fr.result as string)
        }
    }


    return avatarUrl
}

